export const FASES_DA_LICITACAO = [
    { label: 'Aberta', value: 'Aberta' },
    { label: 'Adiada', value: 'Adiada' },
    { label: 'Cancelada', value: 'Cancelada' },
    { label: 'Reaberta', value: 'Reaberta' },
    { label: 'Paralisada', value: 'Paralisada' },
    { label: 'Deserta', value: 'Deserta' },
    { label: 'Fracassada', value: 'Fracassada' },
    { label: 'Em julgamento', value: 'Em julgamento' },
    { label: 'Julgada', value: 'Julgada' },
    { label: 'Adjudicada', value: 'Adjudicada' },
    { label: 'Homologada', value: 'Homologada' },
    { label: 'Revogada', value: 'Revogada' },
    { label: 'Em andamento', value: 'Em andamento' },
    { label: 'Em análise de Propostas', value: 'Em análise de Propostas' },
    { label: 'Em análise de Habilitação', value: 'Em análise de Habilitação' },
    { label: 'Processo Concluído', value: 'Processo Concluído' }
];



// WEBPACK FOOTER //
// ./src/app/_mocks/fasesDaLicitacao.ts